module.exports = __webpack_public_path__ + "static/media/classev30.74949506.png";